import React from 'react';

const logoUrl = '/images/Logo/logo.png';
const backgroundImageUrl = '/images/background/background-splashscreen.png';

export function SplashScreen() {
  return (
    <div
      className="flex flex-col items-center justify-center min-h-screen bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImageUrl})` }}
    >
      <img
        src={logoUrl}
        alt="App Logo"
        className="w-32 h-32 animate-pulse"
      />
    </div>
  );
} 